import {
  addCalendarDays,
  LISTING_ACTION_MAX_DAYS,
  viennaInstant,
  viennaToday,
} from '@pulsify/shared'

export type ActionEndChoice = { mode: 'today'; time: string } | { mode: 'day'; date: string }

export const DEFAULT_ACTION_END: ActionEndChoice = { mode: 'today', time: '23:59' }

/** The days an action can run until besides today: tomorrow up to the sixth day after today. */
export function actionEndDays(now: Date): string[] {
  const today = viennaToday(now).date
  return Array.from({ length: LISTING_ACTION_MAX_DAYS - 1 }, (_, index) =>
    addCalendarDays(today, index + 1),
  )
}

/** The instant a choice names in Vienna: a time today, or the last minute of a later day. */
export function actionEndsAt(choice: ActionEndChoice, now: Date): Date {
  return choice.mode === 'today'
    ? viennaInstant(viennaToday(now).date, choice.time)
    : viennaInstant(choice.date, '23:59')
}

export function isActionEndChoiceValid(choice: ActionEndChoice, now: Date): boolean {
  if (choice.mode === 'today' && !/^\d{2}:\d{2}$/.test(choice.time)) return false
  return actionEndsAt(choice, now).getTime() > now.getTime()
}
